import type { IdealJob } from "@/models/idealJob";

export const emptyIdealJob = (): IdealJob => {
  return { title: "", description: "", skills: [] };
};
